import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/*
 * This hook sets the document title based on the current route.
 * @param {Array} routes - An array of route objects.
 *
 */
export function useDocumentTitleFromRoute(routes) {
	const location = useLocation();

	useEffect(() => {
		const currentRoute = routes.find(
			(route) => route.path === location.pathname,
		);
		if (currentRoute && currentRoute.title) {
			document.title = currentRoute.title;
		} else {
			document.title = 'CAN apps'; // Fallback title
		}
	}, [location, routes]);
}
